import { useState, useEffect } from 'react';
import { useProfileStore } from '../../../store/models/profile';
import { usePublisherStore } from '../../../store/models/publisher';

function useProfilePanel() {
    const profileStore = useProfileStore();
    const publisherStore = usePublisherStore();

    const [profileDisplay, setProfileDisplay] = useState({});
    const [collections, setCollections] = useState([]);
    const [recommendedPublishers, setRecommendedPublishers] = useState([]);

    useEffect(() => {
        setProfileDisplay(profileStore.profileDisplay);
    }, [profileStore.observed.profile]);

    useEffect(() => {
        setCollections(profileStore.collections);
    }, [profileStore.observed.collections]);

    useEffect(() => {
        setRecommendedPublishers(publisherStore.recommendedPublishers);
    }, [publisherStore.observed.recommendedPublishers]);

    return { profileDisplay, collections, recommendedPublishers };
}

export default useProfilePanel;
